import publishNotification from "../publishNotification";

/**
 * Fire-and-forget wrapper around publishNotification.
 * Handles the null-guard on token/uuid, the VITE_ENV fallback, and error logging
 * so call sites don't repeat those 6 lines each time.
 */
export function sendTemplateNotification(
  token: string | undefined,
  title: string,
  message: string,
  category: string,
  onError: (err: unknown) => void,
): void {
  if (!token ) return;
  const env = import.meta.env.VITE_ENV || "dev";
  // Use platformId from Redux state (AIDE ID used in GetClient API)
  publishNotification(token, env, title, message, "low", category ).catch(onError);
}
